export default {
  ccv_title: 'Age Confirmation',
  ccv_birthDate: 'Date of Birth',
  ccv_day: 'Day',
  ccv_month: 'Month',
  ccv_year: 'Year',
  ccv_privacyNote:
    'Age data is collected exclusively for account authentication and will not be stored. Please note that once confirmed, your country and age information cannot be modified.',
  ccv_readCarefully: 'Please read carefully',
  ccv_agreeTerms: 'I have read and agree to the ${terms}',
  ccv_agreeAll: 'Agree to All',
  ccv_continue: 'Continue',
  ccv_parentConsent: 'Parent/guardian permission needed to continue.',
  ccv_deviceToParent: `Please hand your device to your parent/guardian. We'll guide them through a quick consent process.`,
  ccv_agreeGame: `I consent to my child's continued access to this game.`,
  ccv_agreeGameAndAds: `I consent to my child's gameplay access AND data sharing with third-party ad platforms.`,
  ccv_guardianConfirm: 'Parental/Guardian Consent',
  ccv_termsOfService: 'TERMS OF SERVICE',
  ccv_privacyPolicy: 'PRIVACY POLICY',
  ccv_termsOfService1: 'Terms of Service',
  ccv_privacyPolicy1: 'Privacy Policy',
  ccv_guardian: 'Parent/Guardian Consent Form',
  ccv_nextTime: 'Later',
  ccv_checkAgreement: 'To proceed, please check the agreement box.',
  ccv_selectBirthDate: 'Please select your date of birth (yyyy/mm/dd)',
  ccv_protectPay:
    'To protect this transaction, we will initiate a one dollar pre-authorization charge. No actual funds will be charged for this transaction. Please act now',
  ccv_ageGroupTitle: 'Please select your age to start the game',
  ccv_agree: 'Agree',
  ccv_ageGroupAgree:
    'By clicking “Agree,” you agree to our ${terms} and ${privacy}.'
};
